module.exports = __webpack_public_path__ + "static/media/cert_140.8fee1281.jpg";